import React from 'react';
import Tooltip from 'admin/components/common/Tooltip';

type Props = React.ComponentProps<typeof Tooltip>;

const PANEL_TOOLTIP_DELAY = 0.75;

const PanelTooltip = ({ children, placement = 'bottom', ...props }: Props) => (
	<Tooltip {...props} isStatic stylePreset="dark-2" placement={placement} mouseEnterDelay={PANEL_TOOLTIP_DELAY}>
		{children}
	</Tooltip>
);

export default PanelTooltip;
